import { clearAuthenticatedUserContext } from './app-insights-service';
import { UserStorage } from './user-storage';

export interface User {
  id: string;
  email: string;
  isPreTfa?: 'true' | 'false';
  network?: string;
}

export interface LoginProps {
  token: string;
}

type onChangeHandler = ((user: User | undefined) => unknown) | undefined;

const userStorage = new UserStorage();

class AuthService {
  private onChange: onChangeHandler;

  setOnChange(action: onChangeHandler) {
    this.onChange = action;
  }

  logout() {
    userStorage.remove();
    this.onChange?.(undefined);
    clearAuthenticatedUserContext();
  }
}

export const authService = new AuthService();
